<template>
  <div class="col-3">
    <p>Der Prozess für das Räumliche Leitbild schreitet voran und dieser ist nun seit gut einem Jahr unter intensiver Mitwirkung von Stadtrat, Verwaltung und Bürgerschaft in Bearbeitung. Eine grafische Übersicht über den Gesamtprozess haben wir für Sie zusammengestellt.</p>
    <p>
      Eine Übersicht mit allen Downloads finden Sie
      <router-link to="/projekt/downloads">hier</router-link>.
      <br />
      <br />
      <img src="../../assets/grafiken/interaktive_grafik.svg" alt />
    </p>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Prozessübersicht"
  }
};
</script>

<style lang="scss" scoped>
</style>